import * as types from './mutations-types';

export const mutations = {
  [types.EXTRACT_REQUEST_STARTED](state) {
    state.isLoading = true;
    state.error = '';
  },
  [types.EXTRACT_REQUEST_SUCCESS](state) {
    state.isLoading = false;
    state.error = '';
  },
  [types.EXTRACT_REQUEST_FAILURE](state, { error }) {
    state.isLoading = false;
    state.error = error;
  },
  resetExtractData(state) {
    state.isLoading = false;
    state.error = '';
  },
};
